<template>
  <div>
    <!-- top search bar -->
    <div class="pa-5 d-flex">
      <div class="form-input-group flex-grow-1 mr-5">
        <div class="prepend-icon" style="top: 45%;">
          <v-icon>search</v-icon>
        </div>
        <input
          type="text"
          class="pl-42px"
          placeholder="搜尋"
          v-model="filter.keyword"
        />
      </div>
      <TableControlShowState v-model="filter.status"></TableControlShowState>
      <button class="btn btn-primary w-88px" @click="getsrList">搜尋</button>
    </div>
    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px" @click="multiDelete">
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
          <div>
            <button class="btn mr-10px" @click="multiChangeStatus(true)">設為顯示</button>
          </div>
          <div>
            <button class="btn" @click="multiChangeStatus(false)">設為隱藏</button>
          </div>
        </div>
        <tr>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="col-resp-title text-left">Title</th>
          <th class="col-resp-title text-left">Summary</th>
          <th class="text-left">顯示/隱藏</th>
          <th class="text-left">編輯</th>
          <th class="text-left">刪除</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in socialresponsibilityList"
          :key="item.id"
        >
          <td>
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </td>
          <td>{{ item.title }}</td>
          <td>{{ item.summary }}</td>
          <td>
            <FormSwitch v-model="item.status"
                        @changeStatus="toggleStatus(item.id)"></FormSwitch>
          </td>
          <td>
            <button class="btn square" @click="toSocialRespEdit(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </td>
          <td>
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="getsrList" model="socialresponsibility"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableControlShowState from '@/components/TableControlShowState.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    TableControlShowState,
    FormSwitch,
    Pagination,
    deleteDialog,
  },
  data: () => ({
    // filter
    checkAllStatus: false, // left top checkbox status
    // selectedItems
    selectedItems: [],
  }),
  computed: {
    ...mapState('socialresponsibility', ['socialresponsibilityList', 'filter', 'srTypeOptions']),
    lengthOfisCheckedList() {
      return this.socialresponsibilityList.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      if (
        this.lengthOfisCheckedList === 0 ||
        this.lengthOfisCheckedList === this.socialresponsibilityList.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.socialresponsibilityList.filter((item) => item.isChecked).map((item) => item.id);
    },
    tabName() {
      const tab = this.srTypeOptions.find((item) => item.value === this.filter.tab);
      return tab.text || '';
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.socialresponsibilityList.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.socialresponsibilityList.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    ...mapActions('socialresponsibility', {
      getsrList: 'find',
      destroySocialresponsibility: 'destroy',
      clear: 'clear',
      changeStatus: 'changeStatus',
    }),
    toSocialRespEdit(id) {
      this.$router.push({
        name: 'SocialRespEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.socialresponsibilityList.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.socialresponsibilityList.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroySocialresponsibility(id).then(() => {
        this.getsrList();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroySocialresponsibility(id).then(() => {});
      });
      this.getsrList();
    },
    async multiChangeStatus(status) {
      await this.isCheckedListIds.forEach((id) => {
        this.changeStatus({
          id, status,
        }).then(() => {});
      });
      this.getsrList();
    },
    toggleStatus(id) {
      this.changeStatus({ id }).then(() => {
        this.getsrList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  .col-date {
    width: 75px;
    margin-right: 40px;
  }
  .col-resp-title {
    width: 250px;
    margin-right: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .col-show {
    margin: 0 20px;
  }
}
</style>
